import { create } from 'zustand';

/**
 * 당겨서 새로고침 버스. 홈 화면 앱(PWA standalone)에는 브라우저 새로고침 버튼이
 * 없어서, 화면들이 이 tick을 구독했다가 값이 바뀌면 자기 데이터를 다시 불러온다.
 * 전체 reload보다 가볍고 스크롤·상태가 유지된다.
 */
interface RefreshState {
  tick: number;
  bump: () => void;
}

export const useRefreshStore = create<RefreshState>((set) => ({
  tick: 0,
  bump: () => set((s) => ({ tick: s.tick + 1 })),
}));
